//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  IEnableLike2BuyRequest,
  IGetInstagramSettingsResponse,
} from '@apis/instagram-settings/instagramSettingsApiModel';
import { sessionFetch } from '@utils/sessionFetch';

const instagramSettingsFetch = (endpoint: string, init?: RequestInit) => {
  return sessionFetch(`/api/settings/instagram${endpoint}`, init);
};

export const getInstagramSettings = async (
  init?: RequestInit,
): Promise<IGetInstagramSettingsResponse> => {
  const res = await instagramSettingsFetch('', init);
  return await res.json();
};

/**
 * Sets up a Like2Buy store with the given Instagram
 * account id & username for the current client.
 *
 * /api/settings/instagram/like2buy/enable
 */
export const enableLike2Buy = async (
  req: IEnableLike2BuyRequest,
): Promise<void> => {
  await instagramSettingsFetch('/like2buy/enable', {
    method: 'POST',
    body: JSON.stringify(req),
  });
};

/**
 * Disconnects Like2Buy store for the current Instagram account
 *
 * /api/settings/instagram/like2buy/disconnect
 */
export const disconnectLike2Buy = async (): Promise<void> => {
  await instagramSettingsFetch('/like2buy/disconnect', {
    method: 'DELETE',
  });
};
